import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import * as serviceCaseActionTypes from '../serviceCaseActionTypes';
import updateServiceCase from './updateServiceCase';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';

/**
 * Update service case basic data flow
 */
const updateSCBasicDataFlow = function* updateSCBasicDataFlow() {
    while (true) {
        const {payload} = yield take(serviceCaseActionTypes.INITIATE_UPDATE_SC_BASIC_DATA_FLOW);
        const lockContext = {};
        const {serviceCaseData, caseType, serviceCaseId, serviceAssignmentData} = payload;

        yield* updateServiceCase({
            lockContext,
            caller: serviceCaseActionTypes.INITIATE_UPDATE_SC_BASIC_DATA_FLOW,
            caseType,
            serviceCaseId,
            serviceCaseData,
        });

        yield* updateServiceAssignment({
            lockContext,
            caller: serviceCaseActionTypes.INITIATE_UPDATE_SC_BASIC_DATA_FLOW,
            assignmentType: serviceAssignmentData.assignmentType,
            serviceAssignmentLineNo: serviceAssignmentData.serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData: {
                callbackPhoneNo: serviceAssignmentData.callbackPhoneNo,
                secondCallbackPhoneNo: serviceAssignmentData.secondCallbackPhoneNo,
            },
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: serviceCaseActionTypes.INITIATE_UPDATE_SC_BASIC_DATA_FLOW},
        });
    }
};

export default updateSCBasicDataFlow;
